import cx from "classnames"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import React from "react"
import Paper from "components/Paper"
import * as css from "./Img.module.css"

function Img(props) {
  const {
    src,
    rawImage,
    paper,
    hoverable,
    hero,
    className,
    wrapperClassName,
    classes = {},
    alt,
    image,
    withArtDirection,
    loading = "lazy",
    ...rest
  } = props

  // Warn in development if alt text is missing
  if (process.env.NODE_ENV === "development" && !alt && alt !== "") {
    console.warn(`[Img] Missing alt text for image: ${src || "gatsby-image"}`)
  }

  const classNames = cx(css.image, className, classes.image)
  const imageProps = {
    src,
    alt: alt || "",
    className: classNames,
    image: withArtDirection ? image : getImage(image),
    ...rest,
  }

  // Use raw img tag for:
  // - rawImage prop set to true
  // - External URLs (http/https)
  // - Local static paths (starting with /)
  const isRawImage =
    rawImage ||
    (typeof src === "string" && /https?:\/\//.test(src)) ||
    (typeof src === "string" && src.startsWith("/"))

  const ImageComponent = isRawImage ? "img" : GatsbyImage

  // Add native lazy loading for raw images (GatsbyImage handles this automatically)
  if (isRawImage) {
    imageProps.loading = loading
  }

  // Guard against missing image for GatsbyImage
  if (!isRawImage && !imageProps.image) {
    return null
  }

  if (paper) {
    return (
      <Paper
        hero={hero}
        className={cx(css.paper, classes.paper, wrapperClassName)}
        hoverable={hoverable}
      >
        <ImageComponent {...imageProps} />
      </Paper>
    )
  }

  return <ImageComponent {...imageProps} />
}

Img.propTypes = {
  src: PropTypes.string,
  rawImage: PropTypes.bool,
  paper: PropTypes.bool,
  hoverable: PropTypes.bool,
  hero: PropTypes.bool,
  alt: PropTypes.string,
  image: PropTypes.shape({}),
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  classes: PropTypes.shape({
    image: PropTypes.string,
    paper: PropTypes.string,
  }),
  withArtDirection: PropTypes.bool,
  /** Native lazy loading ("lazy", "eager", "auto") - defaults to "lazy" */
  loading: PropTypes.oneOf(["lazy", "eager", "auto"]),
}

export default Img
